export default __webpack_public_path__ + "static/media/logo.7c21d9f6.png";